import { render, staticRenderFns } from "./CampaignActivationModal.vue?vue&type=template&id=c94f002a&scoped=true&"
import script from "./CampaignActivationModal.vue?vue&type=script&lang=ts&"
export * from "./CampaignActivationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignActivationModal.vue?vue&type=style&index=0&id=c94f002a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94f002a",
  null
  
)

export default component.exports